/** @format */

export const studyYearModelModule = 'sis-components.model.studyYear';

(function () {
    studyYearJSDataModel.$inject = ['DS', 'StudyYearEndpoint'];
    angular
        .module(studyYearModelModule, ['js-data'])
        .factory('studyYearJSDataModel', studyYearJSDataModel)
        .constant('StudyYearEndpoint', { DEFAULT: '/kori/api/study-years' });

    function studyYearJSDataModel(DS, StudyYearEndpoint) {
        return DS.defineResource({
            idAttribute: 'id',
            name: 'studyYear',
            endpoint: StudyYearEndpoint.DEFAULT,
            computed: {
                id: [
                    'universityOrgId',
                    'valid',
                    function (org, valid) {
                        return _.join([org, valid.startDate || 'null', valid.endDate || 'null'], '_');
                    },
                ],
            },
        });
    }
})();
